import * as React from "react";

import { ILeanSvgIconWithColor } from "../ILeanSvgIconWithColor";

export const hamburger_menu_small: React.FunctionComponent<ILeanSvgIconWithColor> = ({ iconColor, ...rest }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...rest}>
      <path fill="none" stroke={iconColor} d="M20,5.4997 L4,5.4997 M20,19.4997 L4,19.4997 M20,12.4997 L4,12.4997" />
    </svg>
  );
};
